import { TranslateService } from '@ngx-translate/core';
import { ToastController, LoadingController, Loading, AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class NotificationServiceProvider {

    private loading: Loading;
    static readonly SUCCESS:number = 0;
    static readonly ERROR:number = 1;
    static readonly WARNING:number = 2;

    constructor(public toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        private _alertController: AlertController,
        private _translate: TranslateService) {
            
    }

    toast(mensagem) {

        let toast = this.toastCtrl.create({
            message: mensagem,
            duration: 3000,
            showCloseButton: true,
            closeButtonText: this._translate.instant("TOAST.DISPENSAR")
        });

        toast.onDidDismiss(() => {
            //console.log('Dismissed toast');
        });

        toast.present();
    }

    toastWithButton(mensagem, descriptionButton, funcOnDismiss?: any) {

        let toast = this.toastCtrl.create({
          message: mensagem,
          duration: 15000,
          showCloseButton: true,
          closeButtonText: descriptionButton
          
        });
    
        toast.onDidDismiss(funcOnDismiss);
    
        toast.present();
      }
    
      presentLoading(_enableBackdropDismiss?: boolean) {
        this.loading = this.loadingCtrl.create({
          content: this._translate.instant("TOAST.AGUARDE"),
          enableBackdropDismiss: _enableBackdropDismiss
        });
    
        return this.loading.present();
      }
    
      dismissLoading() {
        this.loading.dismiss();
      }
    
      notificacionToast(tipo: any, mensagem: string) {
        let options =
        {
          0: {
            message:this._translate.instant(mensagem),
            duration: 5000,
            position: 'bottom',
            cssClass: 'successToast',
            showCloseButton: true,
            closeButtonText: this._translate.instant('COMMON.CLOSE')
            
          },
          1: {
            message: this._translate.instant(mensagem),
            duration: 5000,
            position: 'bottom',
            cssClass: 'errorToast',
            showCloseButton: true,
            closeButtonText: this._translate.instant('COMMON.CLOSE')
            
          },
          2: {
            message: this._translate.instant(mensagem),
            duration: 5000,
            position: 'bottom',
            cssClass: 'avisoToast',
            showCloseButton: true,
            closeButtonText: this._translate.instant('COMMON.CLOSE')        
          }
        }
    
        let toast = this.toastCtrl.create(options[tipo]);
    
        toast.present();
      }
    
      //ALERT
      presentAlert(_title: string, _subTitle: string, _buttons: any[], _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
          title: _title,
          subTitle: _subTitle,
          buttons: _buttons,
          enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
      }
    
      presentPrompt(_title: string, inputs: any[], _buttons: any[], _subTitle?: string, _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
          title: _title,
          subTitle: _subTitle,
          inputs: inputs,
          buttons: _buttons,
          enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
      }  
    }
    
